import React from 'react'
import { FilteredTreeTable } from '../FilteredTreeTable'
import { Box } from '@mui/material'
import { allWeightedSkillsList } from '../filters'
import { NodeType } from 'shared/types/ingestion'

export function WeightedSkillsConvert({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  return (
    <Box>
      <FilteredTreeTable
        filter={allWeightedSkillsList}
        treeId={treeId}
        versionId={versionId}
        action={{
          actionType: 'typeChange',
          data: { newType: NodeType.SkillsList },
        }}
      />
    </Box>
  )
}
